import React, { useEffect, useState, useMemo } from "react";
import "./RoboTaxiPopup.css";
import {
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText
} from "@mui/material";

const RobotaxiPopNew = ({
  roboTaxiAlert = false,
  selectedPSL = [],
  setSelectedPSL = () => { },
  pslList = [],
  roboTaxiCountError = "",
  setRoboTaxiCountError = () => { },
  handleSaveLimit = () => { },
  onCancelRoboTaxi = () => { }
}) => {
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [groupsInitialized, setGroupsInitialized] = useState(false);
  const [isAllGroupsSelected, setIsAllGroupsSelected] = useState(false);

const groupOptions = useMemo(() => {
  const groups = [...new Set(pslList.map(p => p.groupName))];

  return groups.sort((a, b) => {
    // Keep Default always first (optional but recommended)
    if (a === "Default") return -1;
    if (b === "Default") return 1;
    return a.localeCompare(b, undefined, { numeric: true });
  });
}, [pslList]);


  //Kumar changes
  const selectedPSLNames = useMemo(() => {
    if (!Array.isArray(selectedPSL)) return [];
    return selectedPSL.map(p => p.pslName);
  }, [selectedPSL]);

  useEffect(() => {
    // 👉 Only for EDIT mode initialization
    if (
      roboTaxiAlert &&
      !groupsInitialized &&
      Array.isArray(selectedPSL) &&
      selectedPSL.length > 0
    ) {
      const groupsFromPSL = [
        ...new Set(selectedPSL.map(p => p.groupName).filter(Boolean))
      ];

      setSelectedGroups(groupsFromPSL);
      setGroupsInitialized(true); // 🔒 lock it
    }
  }, [roboTaxiAlert]);

  useEffect(() => {
    if (!roboTaxiAlert) {
      setGroupsInitialized(false);
      setSelectedGroups([]);
    }
  }, [roboTaxiAlert]);

  useEffect(() => {
    if (selectedGroups.length === 0) return;

    const validGroups = selectedGroups.filter(group =>
      groupOptions.includes(group)
    );

    if (validGroups.length !== selectedGroups.length) {
      setSelectedGroups(validGroups);
    }
  }, [groupOptions]);

  useEffect(() => {
    if (selectedPSL.length === 0) return;

    const validPSLs = selectedPSL.filter(psl =>
      groupOptions.includes(psl.groupName)
    );

    if (validPSLs.length !== selectedPSL.length) {
      setSelectedPSL(validPSLs);
    }
  }, [groupOptions]);


  // ✅ Filter PSLs based on selected groups
  const filteredPSLList = selectedGroups.length > 0
    ? pslList.filter(p => selectedGroups.includes(p.groupName))
    : []; // ✅ empty when no group selected

  const handleCancel = () => {
    onCancelRoboTaxi();
  };

  return (
    <>
      {roboTaxiAlert && (
        <div className="popup-container">
          <div className="popup">

            <span className="heading-title">
              Assign Spaces for RoboTaxis
            </span>
            <p>
              <span style={{ fontSize: "12px", fontWeight: 5, marginBottom: "2px", display: "block", textAlign: "left" }}>
                Select a group and parking spaces for robo-taxis.</span>
            </p>
            {/* ================= GROUP ================= */}
            <div style={{ marginBottom: "22px", textAlign: "left" }}>
              <label
                style={{ fontWeight: 600, width: 140 }}
              >
                Group <span style={{ color: "red" }}>*</span>
              </label>
              <FormControl fullWidth size="small">
                <Select
                  multiple
                  displayEmpty
                  value={selectedGroups}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 180,   // 👈 controls dropdown height
                        overflowY: "auto" // 👈 enables vertical scroll
                      }
                    }
                  }}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (value.includes("ALL")) {
                      const allSelected = selectedGroups.length === groupOptions.length;

                      if (allSelected) {
                        setSelectedGroups([]);
                        setIsAllGroupsSelected(false);
                      } else {
                        setSelectedGroups(groupOptions);
                        setIsAllGroupsSelected(true);
                      }

                      setSelectedPSL([]);
                      return;
                    }

                    setSelectedGroups(value);
                    setIsAllGroupsSelected(false); // manual selection
                  }}

                  renderValue={(selected) => {
                    if (selected.length === 0) return "Select Groups";

                    if (isAllGroupsSelected) return "All Groups";

                    return selected.join(", ");
                  }}

                >
                  {/* All Groups Option */}
                  <MenuItem value="ALL">
                    <Checkbox
                      checked={isAllGroupsSelected}
                      indeterminate={
                        selectedGroups.length > 0 &&
                        selectedGroups.length < groupOptions.length
                      }
                    />

                    <ListItemText primary="All Groups" />
                  </MenuItem>

                  {groupOptions.map(group => (
                    <MenuItem key={group} value={group}>
                      <Checkbox checked={selectedGroups.includes(group)} />
                      <ListItemText primary={group} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Parking Spaces - MULTIPLE from filtered groups */}
            <div style={{ marginBottom: "22px", textAlign: "left" }}>
              <label style={{ fontWeight: 600, width: 140 }}>
                Parking Spaces <span style={{ color: "red" }}>*</span>
              </label>

              <FormControl fullWidth size="small">
                <Select
                  multiple
                  displayEmpty
                  value={selectedPSLNames}
                  disabled={selectedGroups.length === 0}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,   // 👈 controls dropdown height
                        overflowY: "auto" // 👈 enables vertical scroll
                      }
                    }
                  }}
                  onChange={(e) => {
                    const values = e.target.value;

                    // 🔥 If ALL clicked
                    if (values.includes("ALL")) {
                      const allSelected =
                        selectedPSLNames.length === filteredPSLList.length;

                      if (allSelected) {
                        // Deselect all
                        setSelectedPSL([]);
                      } else {
                        // Select all
                        const allObjects = filteredPSLList.map(p => ({
                          pslName: p.label,
                          groupName: p.groupName
                        }));
                        setSelectedPSL(allObjects);
                      }

                      setRoboTaxiCountError("");
                      return;
                    }

                    // Normal selection
                    const selectedObjects = values.map(val => {
                      const match = filteredPSLList.find(p => p.label === val);
                      return {
                        pslName: val,
                        groupName: match?.groupName
                      };
                    });

                    setSelectedPSL(selectedObjects);
                    setRoboTaxiCountError("");
                  }}

                  renderValue={(selected) => {
                    if (selected.length === 0) return "Select PSLs";
                    if (filteredPSLList.length > 0 && selected.length === filteredPSLList.length) {
                      return "All PSLs";
                    }
                    return selected.join(", ");
                  }}
                >
                  <MenuItem value="ALL">
                    <Checkbox
                      checked={
                        filteredPSLList.length > 0 &&
                        selectedPSLNames.length === filteredPSLList.length
                      }
                      indeterminate={
                        selectedPSLNames.length > 0 &&
                        selectedPSLNames.length < filteredPSLList.length
                      }
                    />

                    <ListItemText primary="All PSLs" />
                  </MenuItem>

                  {filteredPSLList.length === 0 ? (
                    <MenuItem disabled>
                      <ListItemText primary="Select groups first" />
                    </MenuItem>
                  ) : (
                    filteredPSLList.map((p) => (
                      <MenuItem key={p.id} value={p.label}>
                        <Checkbox checked={selectedPSLNames.includes(p.label)} />
                        {/* <ListItemText primary={`${p.label} (${p.groupName})`} /> */}
                        <ListItemText primary={`${p.label}`} />
                      </MenuItem>
                    ))
                  )}
                </Select>
                {/* Error */}
                {roboTaxiCountError && (
                  <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                    {roboTaxiCountError}
                  </div>
                )}
              </FormControl>
            </div>

            {/* ================= BUTTONS ================= */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "12px"
              }}
            >
              <button className="cancel-buttons" onClick={onCancelRoboTaxi}>
                Cancel
              </button>

              <button className="add-property-btns" onClick={handleSaveLimit}>
                Assign to Robo-taxi
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default RobotaxiPopNew;
